import { appInsights } from '../AppInsights';
import { PriorAuthorizationDomain } from '../interfaces/PriorAuthorizationDomain';
import {
  PriorAuthorizationProcedure,
  PriorAuthorizationRequest,
  PriorAuthorizationServiceDetails,
} from '../interfaces/PriorAuthorizationRequest';
import dataObfuscator from '../services/Obfuscator/dataObfuscator.service';

const ToApiObject = (domainObj: PriorAuthorizationDomain) => {
  const authList: PriorAuthorizationServiceDetails[] = [];
  domainObj.priorAuthorizationDomianDetails.forEach((serviceDetail) => {
    const procedureList: PriorAuthorizationProcedure[] = [];
    serviceDetail.proceduresDetails.forEach((procedureDetail) => {
      procedureList.push({
        modifier1: procedureDetail.modifier,
        modifier2: procedureDetail.modifier2,
        cptCode: procedureDetail.cptCode,
        unitFrequency: procedureDetail.unitFrequency !== '' ? Number(procedureDetail.unitFrequency) : null,
        unitType: procedureDetail.unitType,
        procedureStartDate: procedureDetail.procedureStartDate !== '' ? (new Date((`${procedureDetail.procedureStartDate}Z`))).toISOString() : null,
        lob: procedureDetail.lob,
        processedBy: procedureDetail.processedBy,
      });
    });

    authList.push({
      requestingProvider: {
        taxId: serviceDetail.requestingProvider.taxId.toString(),
        npi: serviceDetail.requestingProvider.npi.toString(),
        cpfId: serviceDetail.requestingProvider.cpfId,
        address: serviceDetail.requestingProvider.address,
        address2: serviceDetail.requestingProvider.address2,
        city: serviceDetail.requestingProvider.city,
        state: serviceDetail.requestingProvider.state,
        zipCode: serviceDetail.requestingProvider.zipCode,
        phone: serviceDetail.requestingProvider.phone,
        firstName: serviceDetail.requestingProvider.firstName,
        lastname: serviceDetail.requestingProvider.lastName,
        facilityName: serviceDetail.requestingProvider.facilityName,
        name: '',
      },
      levelOfUrgency: serviceDetail.levelOfUrgency,
      authorizationType: serviceDetail.authorizationType,
      typeOfService: serviceDetail.typeOfService,
      placeOfService: serviceDetail.placeOfService,
      diagnosisCode: serviceDetail.diagnosisCode,
      medicationNamedCode: serviceDetail.medicationNameNdcCode,
      adjustedDrugDoseDescription: serviceDetail.adjustedDrugDoseDescription,
      medicationFrequency: serviceDetail.medicationFrequency,
      medicationQuantity: serviceDetail.medicationQuantity,
      hcpcUnitsPerDose: serviceDetail.hcpcUnitsPerDose,
      rxDose: serviceDetail.rxDose,
      medicationRoute: serviceDetail.medicationRoute,
      transplantZone: serviceDetail.transplantZone,
      transplantDonorType: serviceDetail.transplantDonorType,
      transplantOrganType: serviceDetail.transplantOrganType,
      requestedDays: serviceDetail.requestedDays,
      serviceRequestId: serviceDetail.serviceRequestId,
      admissionStartDate: serviceDetail.admissionStartDate,
      serviceTypeDescription: serviceDetail.typeOfServiceDescription,
      placeOfServiceDescription: serviceDetail.placeOfServiceDescription,
      levelOfUrgencyDescription: serviceDetail.levelOfUrgencyDescription,
      additionalDiagnosis: serviceDetail.additionalDiagnosis,
      serviceStartDateTime: serviceDetail.admissionStartDate,
      procedures: procedureList,
    });
  });
  const apiObj: PriorAuthorizationRequest = {
    groupingKey: domainObj.groupingKey,
    precertificationId: domainObj.precertificationId,
    transactionId: domainObj.transactionId,
    sourceSystemId: domainObj.sourceSystemId,
    requestSubmittedDate: domainObj.requestSubmittedDate,
    priorAuthorizationHeader: {
      healthPlan:
        domainObj.priorAuthorizationDomainHeader.healthPlan !== null
          ? domainObj.priorAuthorizationDomainHeader.healthPlan : 'cigna',
      partnerId: domainObj.priorAuthorizationDomainHeader.partnerId,
      partnerName: domainObj.priorAuthorizationDomainHeader.partnerName,
      userId: domainObj.priorAuthorizationDomainHeader.userId,
      memberFirstname: domainObj.priorAuthorizationDomainHeader.memberFirstName,
      memberLastName: domainObj.priorAuthorizationDomainHeader.memberLastName,
      memberDOB: domainObj.priorAuthorizationDomainHeader.memberDOB,
      memberId: domainObj.priorAuthorizationDomainHeader.memberId,
      memberGroupNumber: domainObj.priorAuthorizationDomainHeader.memberGroupNumber,
      servicingProvider: {
        taxId: domainObj.priorAuthorizationDomainHeader.servicingProvider.taxId,
        npi: domainObj.priorAuthorizationDomainHeader.servicingProvider.npi,
        cpfId: domainObj.priorAuthorizationDomainHeader.servicingProvider.cpfId,
        address: domainObj.priorAuthorizationDomainHeader.servicingProvider.address,
        address2: domainObj.priorAuthorizationDomainHeader.servicingProvider.address2,
        city: domainObj.priorAuthorizationDomainHeader.servicingProvider.city,
        state: domainObj.priorAuthorizationDomainHeader.servicingProvider.state,
        zipCode: domainObj.priorAuthorizationDomainHeader.servicingProvider.zipCode,
        phone: domainObj.priorAuthorizationDomainHeader.servicingProvider.phone,
        firstName: domainObj.priorAuthorizationDomainHeader.servicingProvider.firstName,
        lastname: domainObj.priorAuthorizationDomainHeader.servicingProvider.lastName,
        facilityName: domainObj.priorAuthorizationDomainHeader.servicingProvider.groupName,
        name: domainObj.priorAuthorizationDomainHeader.servicingProvider.name,
      },
    },
    priorAuthorizationBody: [],
  };
  apiObj.priorAuthorizationBody = authList;

  appInsights.trackTrace({ message: `Send to PriorAuthorization API: ${JSON.stringify(dataObfuscator.removeSensitiveApiDtoData(apiObj))}` });

  return apiObj;
};

const DomainToApiObjectMapper = {
  ToApiObject,
};

export default DomainToApiObjectMapper;
